import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { SurveyService } from '../../../service/survey.service';
import { MessageService } from 'src/app/service/message.service';
import { SurveyNewSavingsShortListRequest } from 'src/app/model/survey-request';
import { SurveyNewShortListResponse as SurveyShortListProductResponse, SurveyShortListResponse } from 'src/app/model/survey-response';
import { decodeFlag, encodeFlag } from 'src/app/utils/common.functions';

@Component({
  selector: 'savings-short-list',
  templateUrl: './savings-short-list.component.html',
  styleUrls: ['./savings-short-list.component.scss']
})
export class SavingsShortListComponent implements OnChanges {
  @Input() surveyId!: string;
  @Input() shortList?: SurveyShortListResponse;
  @Input() shortListProducts!: SurveyShortListProductResponse[];
  @Output() complete = new EventEmitter<void>();

  formGroup!: FormGroup;
  loading: boolean = false;
  completed: boolean = false;

  constructor(
    private surveyService: SurveyService,
    private messageService: MessageService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    // Check if the surveyId (new survey) or shortList (show survey) inputs have changed
    if((changes['surveyId'] && changes['surveyId'].firstChange) || changes['shortList']) {
      this.init();
    }
  }

  init(): void {
    this.formGroup = new FormGroup({
      sustainability: new FormControl(encodeFlag(this.shortList?.sustainability), Validators.required),
      patrimonialRatio: new FormControl(this.shortList?.patrimonialRatio, Validators.required),
      solidity: new FormControl(encodeFlag(this.shortList?.solidity), Validators.required),
      companyCode: new FormControl(this.shortList?.companyCode, Validators.required)
    });

    if(!this.isInsert()) {
      this.completed = true;
      this.formGroup.disable();
    } else {
      //TODO move outside
      this.surveyService.getShortList(this.surveyId).subscribe(
        (shortListProducts: SurveyShortListProductResponse[]) => {
          this.shortListProducts = shortListProducts;
        }
      );
    }
  }

  isInsert(): boolean {
    return this.shortList === undefined;
  }

  get sustainability() { return this.formGroup.get('sustainability') }
  get patrimonialRatio() { return this.formGroup.get('patrimonialRatio') }
  get solidity() { return this.formGroup.get('solidity') }
  get companyCode() { return this.formGroup.get('companyCode') }
  
  hasError(field: AbstractControl | null) {
    return !!field && field.touched && !field.disabled && !field.valid;
  }
  
  onSubmit() {
    if(!this.formGroup.valid || this.completed) {
      this.formGroup.markAllAsTouched();
      return;
    }

    this.formGroup.disable();
    this.completed = true;
    this.loading = true;

    const payload: SurveyNewSavingsShortListRequest = {
      sustainability: decodeFlag(this.sustainability?.value),
      patrimonialRatio: this.patrimonialRatio?.value,
      solidity: decodeFlag(this.solidity?.value),
      companyCode: this.companyCode?.value
    }

    this.surveyService.insertSavingsShortListData(this.surveyId, payload).subscribe({
      next: () => {
        this.loading = false;
        this.complete.emit();
      },
      error: () => {
        this.messageService.error('survey.new.message.unknown-error');

        this.loading = false;
        this.completed = false;
        this.formGroup.enable();
      }
    });
  }
}
